<template>
  <el-dialog
    title="开始生产流程"
    :visible.sync="visible"
    label-width="100px"
    width="500px"
    @close="$emit('update:show', false)"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      class="label-long"
      size="small"
    >
      <el-form-item label=""> 产品：{{ model.product_name }} </el-form-item>
      <el-form-item label="流程" prop="flow_template_id">
        <el-select v-model="model.flow_template_id" placeholder="选择流程">
          <el-option
            v-for="item in flowTemplates"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="产品规格" prop="product_size_name">
        <el-select v-model="model.product_size_name" placeholder="选择产品规格">
          <el-option
            v-for="item in sizeCodes"
            :key="item.name"
            :label="item.name"
            :value="item.name"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="流程任务名称" prop="name">
        <el-input v-model="model.name"></el-input>
      </el-form-item>
      <el-form-item label="检验人" prop="inspector_id" v-if="needInspect">
        <el-select v-model="model.inspector_id" placeholder="选择检验人">
          <el-option
            v-for="item in users"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否立即开始任务">
        <!-- <label for class="control-label">
          <small class="help-inline">可前往派工看板开始流程任务</small>
        </label> -->
        <el-checkbox :checked="true" @change="model.fire_mode = $event ? 1 : 0"
          >立即开始</el-checkbox
        >
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="postFlow">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  getInspectors,
  processList,
  newFlow,
  flowTemplates,
} from '@/service/getData'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  computed: {
    needInspect() {
      let b = false
      if (this.model.flow_template_id) {
        let flow = this.flowTemplates.filter(
          (item) => item.id == this.model.flow_template_id
        )[0]

        b = flow.needInspector
      }
      return b
    },
  },
  data() {
    return {
      visible: this.show,
      rules: {
        name: [{ required: true, message: '请填写角色名', trigger: 'blur' }],
        flow_template_id: [
          {
            required: true,
            message: '请选择流程',
            trigger: 'change',
          },
        ],
        product_size_name: [
          {
            required: true,
            message: '请选择产品规格',
            trigger: 'change',
          },
        ],
        inspector_id: [
          { required: true, message: '请选择检验人', trigger: 'change' },
        ],
      },
      sizeCodes: [
        { name: '3~5寸', value: 1 },
        { name: '5~8寸', value: 2 },
        { name: '8~9寸', value: 3 },
        { name: '9~12寸', value: 4 },
        { name: '12~14寸', value: 5 },
        { name: '14~18寸', value: 6 },
      ],
      users: [],
      selectUser: null,
      flowTemplates: [],
      selectFlowTemplate: null,
      selectProjectSize: null,
      startTime: null,
      errorMsg: null,
      flow: {
        name: null,
      },
    }
  },
  created() {
    this.requetFlowTemplates()
    this.initData()
    this.getProducSizes()
  },
  methods: {
    async postFlow() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.model.inspector_id = parseInt(this.model.inspector_id)
          if (this.model.inspector_id > 0) {
            this.model.inspector_name = this.users.filter(
              (item) => item.id == this.model.inspector_id
            )[0].name
          }
          let res = await newFlow(this.model)
          if (res.code == 0) {
            this.$emit('started', res.data)
            this.visible = false
          }
        }
      })
    },

    async initData() {
      let res = await getInspectors()
      this.users = res.data.list || []
    },

    async getProducSizes() {
      let res = await processList()
      if (res.data.length == 0) return
      let sizesObj = res.data[0].sizes
      let sizes = []
      for (const size in sizesObj) {
        sizes.push({ name: size, sort: sizesObj[size].sort })
      }

      sizes.sort(function (x, y) {
        return x.sort - y.sort
      })

      this.sizeCodes = sizes
    },
    async requetFlowTemplates() {
      let res = await flowTemplates()
      this.flowTemplates = res.data.list.map((item) => {
        let needInspector = false
        for (let index = 0; index < item.nodes.length; index++) {
          const node = item.nodes[index]
          if (node.focus_checked) {
            needInspector = true
            break
          }
        }
        item.needInspector = needInspector
        return item
      })
    },
  },
}
</script>

<style>
.label-long .el-form-item__label {
  width: 100%;
  text-align: left;
  line-height: 1.2em !important;
}

.label-long .el-select {
  width: 100%;
}
</style>